import { scrileConnect as ProvidersFactory } from "@scrile/api-provider/dist/";
import Configuration from "@scrile/api-provider/dist/Configuration";
import { IS_BROWSER } from "@/lib/browserUtils";
import emitter from "@/lib/emitter";
import config from "@/config";
import AppStorage from "./appStorage";

export const getManagerProviders = () =>
  ProvidersFactory({
    url: config.apiUrl,
    notificationCB: () => {},
    appStorage: AppStorage,
    websocketOnly: true,
    prefix: "MANAGER",
  });

const providers = ProvidersFactory({
  url: config.apiUrl,
  notificationCB: (event, payload) => {
    emitter.emit(event, payload);
  },
  appStorage: AppStorage,
  websocketOnly: true,
  ...(!IS_BROWSER
    ? {
        fetch: require("node-fetch").default,
        webSocketImpl: require("websocket").w3cwebsocket,
      }
    : {}),
});

Configuration.featureLiveChat = config.featureGoLive;
Configuration.featurePaidMessageAttachments = true;
Configuration.featureFeedPublicReview = config.featureFeedPublicReview;

export default providers.providers;
export const apiTools = providers.apiTools;
